export default "__VITE_ASSET__C3uBluP3__"